import React, { useState } from 'react';
import { Modal, Button, Table } from 'antd';

const VMDumpModal = ({ open, data, onClose }) => {
    console.log("VM Dump Data:", data);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);

    const { cluster_name, data: vmData, totals } = data

    const columns = data?.columns?.map((item) => {

        return {
            title: item,
            dataIndex: item,
            key: item,
            width: 150,
            ellipsis: true,
        }

    })

    return (
        <Modal
            title="Cluster Dump"
            open={open}
            onCancel={onClose}
            onOk={onClose}
            okText="OK"
            cancelText="Cancel"
            width="80vw"
            styles={{
                body: {
                    maxHeight: '70vh',
                    overflow: 'auto',
                    padding: '16px',
                    paddingBottom: '0px',
                },
                footer: {
                    margin: 0,
                },
            }}
           
        >
            <Table
                dataSource={vmData}
                columns={columns}
                pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                    },
                    onShowSizeChange: (current, size) => {
                        setCurrentPage(1);
                        setPageSize(size);
                    },
                }}
                bordered
                size="small"
                scroll={{ x: 'max-content', y: 'calc(70vh - 200px)' }}
                style={{ marginBottom: "20px" }}
            />
        </Modal>
    );
};

export default VMDumpModal;